import { ReactNode } from "react";
import Flickity from "react-flickity-component";
import styled, { css } from "styled-components";

interface SliderProps {
  children: ReactNode;
  innerDots?: boolean;
}

interface FlickityProps {
  innerDots?: boolean;
}

export function Slider({ children, innerDots = false }: SliderProps) {
  const flickityOptions = {
    initialIndex: 0,
    wrapAround: true,
  };

  return (
    <FlickityUI
      className={'carousel'} 
      elementType={'div'}
      options={flickityOptions}
      disableImagesLoaded={false}
      innerDots={innerDots}
      reloadOnUpdate
      static
    >
      {children}
    </FlickityUI>
  );
}

const FlickityUI: any = styled(Flickity)<FlickityProps>`
  ${({ innerDots }) => innerDots && css`
    position: relative;
  `}
  
  .flickity-viewport {
    overflow: hidden;
  }

  .flickity-button {
    display: none;
  }

  .flickity-page-dots {
    display: flex;
    justify-content: center;
    padding: 14px 0 0;

    ${({ innerDots }) => innerDots && css`
      @media screen and (min-width: 1212px) {
        position: absolute;
        bottom: 20px;
        right: calc(((100vw - 1212px) / 2) + 36px);
      }
    `}

    .dot {
      width: 14px;
      height: 14px;
      border-radius: 100%;
      border: ${({ theme }) => `2px solid ${theme.colors.blue.dark}`};
      font-size: 0;
      margin: 0 2px;

      &.is-selected {
        background-color: ${({ theme }) => theme.colors.blue.dark};
      }
    }
  }
`;